export default __webpack_public_path__ + "static/media/pr_c_13.c8ca4d34.jpg";